import React from 'react';
import { isValid, parseJSON } from 'date-fns';

import { Text } from '@reckon-web/text';

import { DateUtils } from '../../../utils/date-utils';

interface IActivityPropertyDate {
  value?: string | null;
}

// ActivityProperty Date = 5
export const ActivityPropertyDate = ({ value }: IActivityPropertyDate) => {
  const formattedValue = () => {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const parsedVal = parseJSON(value);
    if (!isValid(parsedVal)) {
      // we tried, doesn't parse, just return the string
      return value;
    }

    // these will be just points in time
    // just display them as is (parseJSON will already convert from UTC)
    return DateUtils.formatDateShort(parsedVal);
  };

  return (
    <Text size="small" weight="semibold">
      {formattedValue()}
    </Text>
  );
};
